import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "content-img"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "content-wrap"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "desc van-multi-ellipsis--l3"
};
const _hoisted_7 = {
  class: "detail-btn"
};
import { useRouter } from 'vue-router';
import { getServerImage } from '@/utils/images';
export default {
  __name: 'index',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const router = useRouter();
    const props = __props;
    const handleDetail = scenicInfo => {
      // 获取当前路由路径，判断是著名景点还是低碳园林
      const currentPath = window.location.hash;
      const isLowCarbon = currentPath.includes('/lowcarbon');
      const path = isLowCarbon ? '/lowcarbon/detail' : '/scenic/detail';

      // 通过路由 query 传递 tab 信息
      router.push({
        path: `${path}/${scenicInfo.id}`,
        query: {
          tabTitle: scenicInfo.tabName
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, scenicInfo => {
        return _openBlock(), _createElementBlock("div", {
          class: "container",
          key: scenicInfo.id,
          onClick: $event => handleDetail(scenicInfo)
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          src: _unref(getServerImage)(scenicInfo.imgUrl),
          alt: scenicInfo.title
        }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(scenicInfo.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(scenicInfo.introduction), 1), _createElementVNode("div", _hoisted_7, [_cache[0] || (_cache[0] = _createElementVNode("span", null, "更多详情", -1)), _createVNode(_component_van_icon, {
          name: "arrow"
        })])])], 8, _hoisted_1);
      }), 128))]);
    };
  }
};